import '../css/index.less';
import LinePlayer from './player';
console.log('\n'.concat(' %c LinePlayer ', LINEPLAYER_VERSION, ' ').concat(GIT_HASH, ' %c https://github.com/andresys/LinePlayer ', '\n', '\n'), 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');
export default LinePlayer;